export default __webpack_public_path__ + "static/media/080_finish_soso.last.e9d57490.png";